#import "../fragments/landing-page-stub-fragment.graphql"

mutation UndeleteLandingPage($input: PageUndeleteInput!) {
    pageUndelete(input: $input) {
        page {
            ...LandingPageStubFragment
        }
    }
}
